import { useState } from 'react';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl -translate-x-1/4 translate-y-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 pt-[72px]">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-10 md:py-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-5 whitespace-nowrap">
              追剧党都在用
            </span>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              久久影视
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground-700 font-normal mt-2">
                最新电视剧更新与电影上映
              </span>
            </h1>

            <p className="text-lg md:text-xl font-heading text-primary-600 mb-6">
              追剧党的一站式片单，新剧综艺抢先看
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              久久影视同步全网最新电视剧更新与最新电影上映动态，覆盖国产剧、海外剧、院线新片和热门综艺。
              影视更新快、分类清晰，无论你想追新剧、补经典还是发现冷门佳片，这里都是你的私人追剧导航。
              当前正值暑期档热播季，多部重磅新剧和院线大片持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">2000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">热播剧集覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">每日更新</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">同步全网首发</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">高清流畅</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">不卡顿不缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                立即追剧
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            {!imgError ? (
              <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20amber%20and%20deep%20crimson%20tones%2C%20floating%20film%20reels%20and%20soft%20light%20beams%20creating%20a%20dynamic%20atmosphere%2C%20modern%20movie%20entertainment%20platform%20aesthetic%2C%20dark%20gradient%20background%20with%20warm%20glow%20effects%2C%20editorial%20photography%20style%2C%20high%20detail%2C%20atmospheric%20depth%2C%20artistic%20composition&width=1000&height=750&seq=hero-main-visual&orientation=landscape"
                  alt="久久影视 - 最新电视剧更新与电影上映主视觉"
                  className="w-full h-full object-cover object-top rounded-lg"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-background-50/20 to-transparent pointer-events-none"></div>
              </div>
            ) : (
              <div className="w-full max-w-[500px] aspect-[4/3] rounded-lg bg-background-100 flex items-center justify-center">
                <i className="ri-movie-2-line text-6xl text-foreground-300"></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}